import { useIntl } from 'react-intl';
import { NextSeo } from 'next-seo';
import { GetServerSideProps } from 'next';

import { contactMessages } from '@/core/messages/contact.messages';
import { VectorBanner } from '@/core/components/VectorBanner';
import { Color } from '@/core/interfaces/common';
import { navigationMessages } from '@/core/messages/navigation.messages';

import { Contact } from '@/features/Contact';

import { withNavigationData } from '@/utils/withNavigationData';

const Page = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <NextSeo
        title={formatMessage(navigationMessages.contact)}
      />
      <VectorBanner
        header={formatMessage(contactMessages.headingContact)}
        subheader={formatMessage(contactMessages.subheadingContact)}
        color={Color.YELLOW}
      />
      <Contact />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = withNavigationData(async () => ({
  props: {},
}));

export default Page;
